var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5303 10.0303C16.8232 9.73744 16.8232 9.26256 16.5303 8.96967C16.2374 8.67678 15.7626 8.67678 15.4697 8.96967L11 13.4393L9.53033 11.9697C9.23744 11.6768 8.76256 11.6768 8.46967 11.9697C8.17678 12.2626 8.17678 12.7374 8.46967 13.0303L10.4697 15.0303C10.7626 15.3232 11.2374 15.3232 11.5303 15.0303L16.5303 10.0303Z",
    fill: "url(#paint0_linear_2598_19718)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.25C6.56294 1.25 1.75 6.06294 1.75 12C1.75 17.9371 6.56294 22.75 12.5 22.75C18.4371 22.75 23.25 17.9371 23.25 12C23.25 6.06294 18.4371 1.25 12.5 1.25ZM3.25 12C3.25 6.89137 7.39137 2.75 12.5 2.75C17.6086 2.75 21.75 6.89137 21.75 12C21.75 17.1086 17.6086 21.25 12.5 21.25C7.39137 21.25 3.25 17.1086 3.25 12Z",
    fill: "url(#paint1_linear_2598_19718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2598_19718",
    x1: 3.43308,
    y1: -2.81111,
    x2: 3.43307,
    y2: 31.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2598_19718",
    x1: 3.43308,
    y1: -2.81111,
    x2: 3.43307,
    y2: 31.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288564"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1e135273ca634219460ab16ad424da2f.svg";
export { ForwardRef as ReactComponent };